"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "flex items-center gap-1" };
const _hoisted_2 = /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "marso-icon-psg1 text-2xl" }, null, -1);
const _hoisted_3 = { class: "flex items-center gap-1" };
const _hoisted_4 = /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "marso-icon-suv2 text-2xl" }, null, -1);
const _hoisted_5 = { class: "flex items-center gap-1" };
const _hoisted_6 = /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "marso-icon-cargo2 text-2xl" }, null, -1);
const vue_3 = require("vue");
const DropdownInput_vue_1 = __importDefault(require("../../components/Form/DropdownInput/DropdownInput.vue"));
const Form_1 = require("../../components/Form");
const tyre_search_1 = require("../../components/ProductSearch/tyre-search");
const TyreFilter_vue_1 = __importDefault(require("../../components/ProductSearch/TyreFilter.vue"));
const vue_router_1 = require("vue-router");
const DropdownInputItem_1 = __importDefault(require("../../components/Form/DropdownInput/DropdownInputItem"));
const i18n_1 = require("../../common/i18n");
const fetch_1 = __importDefault(require("../../common/utils/fetch"));
const productFilterStore_1 = require("../../stores/product/filter/productFilterStore");
exports.default = (0, vue_1.defineComponent)({
    __name: 'ProductPassengerTyres',
    setup(__props) {
        const route = (0, vue_router_1.useRoute)();
        const router = (0, vue_router_1.useRouter)();
        const productFilterStore = (0, productFilterStore_1.useProductFilterStore)();
        const tyreFilterRef = (0, vue_3.ref)(null);
        const seasonSelect = (0, vue_3.ref)(tyre_search_1.defaultSeason);
        const passengerToggle = (0, vue_3.ref)(false);
        const suvToggle = (0, vue_3.ref)(false);
        const vanToggle = (0, vue_3.ref)(false);
        const selectedHomologatedNotation = (0, vue_3.ref)(null);
        const homologations = (0, vue_3.ref)([]);
        const seasonSelectItems = (0, vue_3.ref)([
            new DropdownInputItem_1.default("summer", `<div><i class="marso-icon-summer"></i> ${(0, i18n_1.trans)("summer_tyre", "Summer tyre", "passenger_tyres")}</div>`),
            new DropdownInputItem_1.default("winter", `<i class="marso-icon-winter"></i> ${(0, i18n_1.trans)("winter_tyre", "Winter tyre", "passenger_tyres")}`),
            new DropdownInputItem_1.default("all_season", `<i class="marso-icon-all_season"></i> ${(0, i18n_1.trans)("all_season_tyre", "All season tyre", "passenger_tyres")}`),
        ]);
        const form = (0, vue_3.ref)(Object.assign({}));
        form.value = Object.assign(form.value, tyre_search_1.carTyreSearchForm);
        const initQueryParams = (0, tyre_search_1.getQueryParams)(form.value, route);
        for (const key in initQueryParams) {
            if (initQueryParams.hasOwnProperty(key)) {
                if (key === "axCategories") {
                    seasonSelect.value = (0, tyre_search_1.calculateSeason)(initQueryParams[key]);
                    passengerToggle.value = (0, tyre_search_1.isPassengerCarTyre)(initQueryParams[key]);
                    suvToggle.value = (0, tyre_search_1.isSuvCarTyre)(initQueryParams[key]);
                    vanToggle.value = (0, tyre_search_1.isVanCarTyre)(initQueryParams[key]);
                    form.value['axCategory'] = initQueryParams[key];
                }
                form.value[key] = initQueryParams[key];
            }
        }
        const filterValues = (0, vue_3.computed)(() => productFilterStore.productFilters);
        const homologated_notations = (0, vue_3.computed)(() => {
            const uniqueCarBrands = new Set();
            const localHomologations = homologations.value || [];
            const sortedHomologations = [...localHomologations].sort((a, b) => {
                return a.carBrandName.localeCompare(b.carBrandName);
            });
            return sortedHomologations.reduce((items, homologation) => {
                if (!uniqueCarBrands.has(homologation.carBrandName)) {
                    uniqueCarBrands.add(homologation.carBrandName);
                    const notations = sortedHomologations
                        .filter((h) => h.carBrandName === homologation.carBrandName)
                        .map((h) => h.homologatedNotation)
                        .join(', ');
                    items.push(new DropdownInputItem_1.default(notations, homologation.carBrandName));
                }
                return items;
            }, []);
        });
        const selectedCarTypes = (0, vue_3.computed)(() => {
            const ret = [];
            if (passengerToggle.value) {
                ret.push("passenger");
            }
            if (suvToggle.value) {
                ret.push("suv");
            }
            if (vanToggle.value) {
                ret.push("van");
            }
            return ret;
        });
        const filterValuesCarTypes = (0, vue_3.computed)(() => {
            return ["passenger", "suv", "van"].filter((carType) => {
                var _a;
                return (_a = filterValues.value) === null || _a === void 0 ? void 0 : _a.axCategories.values.some((cat) => (0, tyre_search_1.getIdsForAxCategory)(carType).includes(new String(cat).toString()));
            });
        });
        const getHomologations = async (router) => {
            try {
                const response = await (0, fetch_1.default)(router.resolve({ name: 'shop_homologations_api' }).href);
                if (Array.isArray(response['hydra:member'])) {
                    const validHomologations = response['hydra:member'].filter(item => item['@type'] === 'Homologation');
                    homologations.value.push(...validHomologations);
                }
            }
            catch (error) {
                console.error('Failed to fetch homologations:', error);
            }
        };
        (0, vue_3.onMounted)(() => {
            getHomologations(router);
        });
        (0, vue_3.watch)(seasonSelect, (season) => {
            for (const key in form.value) {
                if (!form.value.hasOwnProperty(key)) {
                    continue;
                }
                if (key === "axCategory") {
                    form.value["axCategory"] = [];
                    for (let prop in tyre_search_1.seasonRules[season]) {
                        form.value["axCategory"].push(tyre_search_1.seasonRules[season][prop]);
                    }
                    passengerToggle.value = true;
                    suvToggle.value = true;
                    vanToggle.value = true;
                    continue;
                }
                if (key === "type") {
                    continue;
                }
                // Removed because of https://app.clickup.com/t/24406559/DEV-2314
                // form.value[key] = null;
                // tyreFilterRef.value?.resetTagSearchInput();
            }
        });
        (0, vue_3.watch)(() => passengerToggle.value, () => (form.value.axCategory = (0, tyre_search_1.calculateAxCategory)(seasonSelect.value, selectedCarTypes.value)));
        (0, vue_3.watch)(() => suvToggle.value, () => (form.value.axCategory = (0, tyre_search_1.calculateAxCategory)(seasonSelect.value, selectedCarTypes.value)));
        (0, vue_3.watch)(() => vanToggle.value, () => (form.value.axCategory = (0, tyre_search_1.calculateAxCategory)(seasonSelect.value, selectedCarTypes.value)));
        (0, vue_3.watch)(selectedHomologatedNotation, () => {
            if (selectedHomologatedNotation.value !== null) {
                if (selectedHomologatedNotation.value.includes(",")) {
                    //Ha van vessző, akkor feldaraboljuk és tömbbe rakjuk
                    form.value.homologatedNotations =
                        selectedHomologatedNotation.value.split(",").map(item => item.trim());
                }
                else {
                    form.value.homologatedNotations = [selectedHomologatedNotation.value.trim()];
                }
            }
            else {
                //Ha a dropdownból töröljük az értéket akkor frissítse be az oldalt
                form.value.homologatedNotations = [];
            }
        });
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(TyreFilter_vue_1.default, {
                searchLabel: (0, vue_2.unref)(i18n_1.trans)('passenger_tyre_search', 'Passenger tyre search', 'passenger_tyres'),
                form: form.value,
                placeholder: (0, vue_2.unref)(i18n_1.trans)('tag_search_input_placeholder', 'eg. 2055516 nokian', 'passenger_tyres'),
                category: "carTyre",
                ref_key: "tyreFilterRef",
                ref: tyreFilterRef,
                hasAdditionalFilters: "",
                listFields: (0, vue_2.unref)(tyre_search_1.carTyreProductListFields)
            }, {
                filtersPrepend: (0, vue_2.withCtx)(() => [
                    (0, vue_2.createVNode)(DropdownInput_vue_1.default, {
                        placeholder: (0, vue_2.unref)(i18n_1.trans)('season', 'Season', 'passenger_tyres'),
                        items: seasonSelectItems.value,
                        modelValue: seasonSelect.value,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((seasonSelect).value = $event)),
                        "disable-deselect": ""
                    }, null, 8, ["placeholder", "items", "modelValue"])
                ]),
                additionalFilters: (0, vue_2.withCtx)(() => {
                    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
                    return [
                        (0, vue_2.createVNode)((0, vue_2.unref)(Form_1.Toggle), {
                            class: "px-2 bg-gray justify-between",
                            modelValue: passengerToggle.value,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((passengerToggle).value = $event)),
                            disabled: !(0, vue_2.unref)(filterValuesCarTypes).includes('passenger')
                        }, {
                            label: (0, vue_2.withCtx)(() => [
                                (0, vue_2.createElementVNode)("span", _hoisted_1, [
                                    _hoisted_2,
                                    (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("passenger", "Passenger", "passenger_tyres")), 1)
                                ])
                            ]),
                            _: 1
                        }, 8, ["modelValue", "disabled"]),
                        (0, vue_2.createVNode)((0, vue_2.unref)(Form_1.Toggle), {
                            class: "px-2 bg-gray justify-between",
                            modelValue: suvToggle.value,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((suvToggle).value = $event)),
                            disabled: !(0, vue_2.unref)(filterValuesCarTypes).includes('suv')
                        }, {
                            label: (0, vue_2.withCtx)(() => [
                                (0, vue_2.createElementVNode)("span", _hoisted_3, [
                                    _hoisted_4,
                                    (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("suv_4x4", "SUV, 4x4", "passenger_tyres")), 1)
                                ])
                            ]),
                            _: 1
                        }, 8, ["modelValue", "disabled"]),
                        (0, vue_2.createVNode)((0, vue_2.unref)(Form_1.Toggle), {
                            class: "px-2 bg-gray justify-between",
                            modelValue: vanToggle.value,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((vanToggle).value = $event)),
                            disabled: !(0, vue_2.unref)(filterValuesCarTypes).includes('van')
                        }, {
                            label: (0, vue_2.withCtx)(() => [
                                (0, vue_2.createElementVNode)("span", _hoisted_5, [
                                    _hoisted_6,
                                    (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("van", "Van", "passenger_tyres")), 1)
                                ])
                            ]),
                            _: 1
                        }, 8, ["modelValue", "disabled"]),
                        (0, vue_2.createVNode)((0, vue_2.unref)(Form_1.Toggle), {
                            label: (0, vue_2.unref)(i18n_1.trans)('ev', 'EV', 'passenger_tyres'),
                            class: "p-2 bg-gray justify-between",
                            modelValue: form.value.isForElectricVehicle,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((form.value.isForElectricVehicle) = $event)),
                            disabled: !((_a = (0, vue_2.unref)(filterValues)) === null || _a === void 0 ? void 0 : _a.containsForElectricVehicles.values)
                        }, null, 8, ["label", "modelValue", "disabled"]),
                        (0, vue_2.createVNode)((0, vue_2.unref)(Form_1.Toggle), {
                            label: (0, vue_2.unref)(i18n_1.trans)('run_flat', 'Run flat', 'passenger_tyres'),
                            class: "p-2 bg-gray justify-between",
                            modelValue: form.value.runFlat,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((form.value.runFlat) = $event)),
                            disabled: !((_b = (0, vue_2.unref)(filterValues)) === null || _b === void 0 ? void 0 : _b.containsRunFlats.values)
                        }, null, 8, ["label", "modelValue", "disabled"]),
                        (0, vue_2.createVNode)((0, vue_2.unref)(Form_1.Toggle), {
                            label: (0, vue_2.unref)(i18n_1.trans)('reinforced', 'Reinforced', 'passenger_tyres'),
                            class: "p-2 bg-gray justify-between",
                            modelValue: form.value.isReinforcedVersion,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((form.value.isReinforcedVersion) = $event)),
                            disabled: !((_c = (0, vue_2.unref)(filterValues)) === null || _c === void 0 ? void 0 : _c.containsReinforcedVersions.values)
                        }, null, 8, ["label", "modelValue", "disabled"]),
                        (0, vue_2.createVNode)((0, vue_2.unref)(Form_1.Toggle), {
                            label: (0, vue_2.unref)(i18n_1.trans)('rim_fringe_protector', 'Rim fringe protector', 'passenger_tyres'),
                            class: "p-2 bg-gray justify-between",
                            modelValue: form.value.isRimFringeProtector,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((form.value.isRimFringeProtector) = $event)),
                            disabled: !((_d = (0, vue_2.unref)(filterValues)) === null || _d === void 0 ? void 0 : _d.containsRimFringeProtectors.values)
                        }, null, 8, ["label", "modelValue", "disabled"]),
                        (0, vue_2.createVNode)(DropdownInput_vue_1.default, {
                            placeholder: (0, vue_2.unref)(i18n_1.trans)('speed_index', 'Speed index', 'passenger_tyres'),
                            items: (_e = (0, vue_2.unref)(filterValues)) === null || _e === void 0 ? void 0 : _e.speedIndexes.values,
                            modelValue: form.value.speedIndex,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((form.value.speedIndex) = $event))
                        }, null, 8, ["placeholder", "items", "modelValue"]),
                        (0, vue_2.createVNode)(DropdownInput_vue_1.default, {
                            placeholder: (0, vue_2.unref)(i18n_1.trans)('load_capacity', 'Load capacity', 'passenger_tyres'),
                            items: (_f = (0, vue_2.unref)(filterValues)) === null || _f === void 0 ? void 0 : _f.loadIndexes.values,
                            modelValue: form.value.loadIndex,
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((form.value.loadIndex) = $event))
                        }, null, 8, ["placeholder", "items", "modelValue"]),
                        (0, vue_2.createVNode)(DropdownInput_vue_1.default, {
                            placeholder: (0, vue_2.unref)(i18n_1.trans)('homologated_notation', 'Homologated notation', 'passenger_tyres'),
                            items: (0, vue_2.unref)(homologated_notations),
                            modelValue: selectedHomologatedNotation.value,
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => ((selectedHomologatedNotation).value = $event))
                        }, null, 8, ["placeholder", "items", "modelValue"]),
                        (0, vue_2.createVNode)(DropdownInput_vue_1.default, {
                            placeholder: (0, vue_2.unref)(i18n_1.trans)('fuel_consumption', 'Fuel consumption', 'passenger_tyres'),
                            items: (_g = (0, vue_2.unref)(filterValues)) === null || _g === void 0 ? void 0 : _g.fuelEfficiencies.values,
                            modelValue: form.value.fuelEfficiency,
                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => ((form.value.fuelEfficiency) = $event))
                        }, null, 8, ["placeholder", "items", "modelValue"]),
                        (0, vue_2.createVNode)(DropdownInput_vue_1.default, {
                            placeholder: (0, vue_2.unref)(i18n_1.trans)('wet_grip', 'Wet grip', 'passenger_tyres'),
                            items: (_h = (0, vue_2.unref)(filterValues)) === null || _h === void 0 ? void 0 : _h.wetGripClasses.values,
                            modelValue: form.value.wetGripClass,
                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event) => ((form.value.wetGripClass) = $event))
                        }, null, 8, ["placeholder", "items", "modelValue"]),
                        (0, vue_2.createVNode)(DropdownInput_vue_1.default, {
                            placeholder: (0, vue_2.unref)(i18n_1.trans)('noise_measurement', 'Noise measurement', 'passenger_tyres'),
                            items: (_j = (0, vue_2.unref)(filterValues)) === null || _j === void 0 ? void 0 : _j.noiseMeasurementClasses.values,
                            modelValue: form.value.noiseMeasurementClass,
                            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event) => ((form.value.noiseMeasurementClass) = $event))
                        }, null, 8, ["placeholder", "items", "modelValue"])
                    ];
                }),
                _: 1
            }, 8, ["searchLabel", "form", "placeholder", "listFields"]));
        };
    }
});
